module.exports = __webpack_public_path__ + "img/a6d28145.png";